import { render, staticRenderFns } from "./ModalAddBed.vue?vue&type=template&id=1e5f343a&scoped=true"
import script from "./ModalAddBed.vue?vue&type=script&lang=js"
export * from "./ModalAddBed.vue?vue&type=script&lang=js"
import style0 from "./ModalAddBed.vue?vue&type=style&index=0&id=1e5f343a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5f343a",
  null
  
)

export default component.exports